module.exports = __webpack_public_path__ + "7fe25a52522ec7a15e1b20bee5a82ac9.png";